import appConfig from '@consumer-talent.config/appConfig';
import { CarouselImage } from '@minecraft.molecules';

/**
 * Headshot samples rendered by the "Our Headshot Gallery" module, both on the
 * scheduling page and in the upsell / info modals.
 */
export const HEADSHOT_GALLERY_IMAGES: CarouselImage[] = [
  {
    id: 'headshot-1',
    src: `${appConfig.cdnRoot}/images/static/headshot_1.png`,
    alt: 'Headshot gallery sample 1',
  },
  {
    id: 'headshot-2',
    src: `${appConfig.cdnRoot}/images/static/headshot_2.png`,
    alt: 'Headshot gallery sample 2',
  },
  {
    id: 'headshot-3',
    src: `${appConfig.cdnRoot}/images/static/headshot_3.png`,
    alt: 'Headshot gallery sample 3',
  },
  {
    id: 'headshot-4',
    src: `${appConfig.cdnRoot}/images/static/headshot_4.png`,
    alt: 'Headshot gallery sample 4',
  },
  {
    id: 'headshot-5',
    src: `${appConfig.cdnRoot}/images/static/headshot_5.png`,
    alt: 'Headshot gallery sample 5',
  },
  {
    id: 'headshot-6',
    src: `${appConfig.cdnRoot}/images/static/headshot_6.png`,
    alt: 'Headshot gallery sample 6',
  },
];

/** Photos of Formosa Casting Studio rendered by the "Where" module. */
export const STUDIO_IMAGES: CarouselImage[] = [
  {
    id: 'studio-1',
    src: `${appConfig.cdnRoot}/images/static/studio_1.png`,
    alt: 'Formosa Casting Studio interior, photo 1',
  },
  {
    id: 'studio-2',
    src: `${appConfig.cdnRoot}/images/static/studio_2.png`,
    alt: 'Formosa Casting Studio interior, photo 2',
  },
  {
    id: 'studio-3',
    src: `${appConfig.cdnRoot}/images/static/studio_3.png`,
    alt: 'Formosa Casting Studio interior, photo 3',
  },
  {
    id: 'studio-4',
    src: `${appConfig.cdnRoot}/images/static/studio_4.png`,
    alt: 'Formosa Casting Studio interior, photo 4',
  },
  {
    id: 'studio-5',
    src: `${appConfig.cdnRoot}/images/static/studio_5.png`,
    alt: 'Formosa Casting Studio interior, photo 5',
  },
  {
    id: 'studio-6',
    src: `${appConfig.cdnRoot}/images/static/studio_6.png`,
    alt: 'Formosa Casting Studio interior, photo 6',
  },
  {
    id: 'studio-7',
    src: `${appConfig.cdnRoot}/images/static/studio_7.png`,
    alt: 'Formosa Casting Studio interior, photo 7',
  },
];
